import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from 'app/app.component';

// Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const CONTENT_ROUTES: Routes = [
  
  {
    path: 'content-layout',
    loadChildren: () => import('../../pages/content-layout-page/content-pages.module').then(m => m.ContentPagesModule)
  },
  {
    path: 'login',
    loadChildren: () => import('../../pages/content-layout-page/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'login/:id',
    loadChildren: () => import('../../pages/content-layout-page/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'changepassword',
    loadChildren: () =>
      import('../../pages/content-layout-page/changepassword/changepassword.module')
        .then(m => m.ChangepasswordModule)
  },
  {
    path: 'register',
    loadChildren: () => import('../../pages/content-layout-page/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'checkcoverage',
    loadChildren: () => import('../../pages/content-layout-page/checkcoverage/checkcoverage.module').then(m => m.CheckcoverageModule)
  },
  {
    path: 'smspaymenturl',
    loadChildren: () => import('../../pages/full-layout-page/paymenturl/paymenturl.module').then(m => m.PaymenturlModule)
  },
  {
    path: 'homecoverage',
    loadChildren: () => import('../../pages/content-layout-page/homecoverage/homecoverage.module').then(m => m.HomecoverageModule)
  },
  {
    path: 'product',
    loadChildren: () => import('../../pages/content-layout-page/product/product.module').then(m => m.ProductModule)
  },
  {
    path: 'servicesuspendedredirect',
    loadChildren: () => import('../../pages/content-layout-page/servicesuspendedredirect/servicesuspendedredirect.module').then(m => m.ServicesuspendedredirectModule)
  },
  {
    path: 'renewvoucherredirect',
    loadChildren: () => import('../../pages/content-layout-page/renewvoucherredirect/renewvoucherredirect.module').then(m => m.RenewvoucherredirectModule)
  },
  {
    path: 'registerbyreference/:id',
    loadChildren: () => import('../../pages/content-layout-page/registerbyreference/registerbyreference.module').then(m => m.RegisterbyreferenceModule)
  },

  
  
];
